export const data = {


    scene: '03_stairs_up_ok',
    kysymysteksti: 'Hyvä, portaat ylös oikeaoppisesti. Seuraavaksi alaspäin sama juttu.',

    optiot: []


};